import styles from './PdfList.module.scss'

export type PdfListProps = {
	items: {
		title: string
		link: string
	}[]
	topBorder?: boolean
	bottomBorder?: boolean
}

/**
 * Pdf link list
 * @param items - pdf link items
 * @param topBorder - top border flag
 * @param bottomBorder - bottom border flag
 */
export const PdfList = ({ items, topBorder, bottomBorder }: PdfListProps): JSX.Element => (
	<section
		className={`${styles.pdfList} ${topBorder ? styles.topBorder : ''} ${bottomBorder ? styles.bottomBorder : ''}`}>
		<div className={styles.flex}>
			{items.map(item => (
				<div className={styles.item} key={item.title}>
					<a href={item.link} target="_blank" rel="noopener noreferrer" title="Перейти к документу">
						{item.title}
					</a>
				</div>
			))}
		</div>
	</section>
)
